<template>
    <div class="payModalWrap">
        <div class="mask" @click="closeModal"></div>
        <div class="payModalBox">
            <div class="title">确认平台打款信息</div>
            <div class="modalContent">
                <div class="oneArea twoArea">
                    <!-- 清算付款显示的 -->
                    <div v-if="isLiquidation">
                    </div>
                    <!-- 下单的付款 不是清算 -->
                    <div v-if="!isLiquidation">
                        <div class="oneline"><span class="mylabel">下单订单号：</span><span class="text">{{infoObj.orderNumberShow}}</span></div>
                    </div>
                    <div class="oneline"><span class="mylabel">提交时间：</span><span class="text">{{infoObj.order_submit_time}}</span></div>
                    <div class="oneline"><span class="mylabel">支付金额：</span><span class="text">{{infoObj.order_payment_amount}}元</span></div>
                    <div class="oneline"><span class="mylabel">付款说明：</span><span class="text">{{infoObj.order_payment_memo}}</span></div>
                    
                </div>
                <div class="oneArea">
                    <div class="oneline">
                        <div class="oneImgBox" v-for="(list,index) in infoObj.imageFiles">
                            <el-image
                              class="uploadImgAvatar"
                              :src="list"
                              fit="contain"
                              :preview-src-list="infoObj.imageFiles"
                            ></el-image>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="footer">
                <button class="closeBtn btn" @click="submitClick('n')">未收到{{infoObj.order_payment_amount}}元 ，驳回</button>
                <button class="submitBtn btn" @click="submitClick('y')">确定收到{{infoObj.order_payment_amount}}元</button>
            </div>
        </div>

    </div>
</template>

<script>
    import { uploadFileApi } from '../api/public'
    import {   mapState} from 'vuex'
    import {saveOrderPayment,saveOrderPaymentByliquidate,confirmRequestPayment,confirmRequestPaymentByOrder} from '../api/dealer'
    import {getTwoPointerNumber,computeSub} from '../utils/tools.js'
    export default {
        name: 'hexiao',
        props: ["info","isLiquidation"],
        computed: {
            ...mapState({
                userId: state => state.user.userId
            }),
            infoObj() {
                return this.info
            }
        },
        data() {
            return {
                imgsArr:[],//图片数组
                number: "",
                memo:'',
                
                // 上传图片api
                uploadFileApi: '',
                uploadData: {
                  imageType: 12201,
                  imageUserId: ''
                },
                
            }
        },
        watch: {},
        methods: {
            closeModal() {
                this.number = ''
                this.$emit("close")
            },
            closeModalAndSuccess() {
                this.number = ''
                this.$emit("success")
                this.
                initModal()
            },
            initModal(){
                this.imgsArr=[]//图片数组
                this.number=""
                this.memo=''
            },
            submitClick(state) {
                let _this = this
                if(state!='n'&&state!='y'){
                     this.$message.success("只能选择确认或驳回")
                     return false
                }
                if(!this.isLiquidation){
                    let arg = {
                        supplierUserId: _this.infoObj.supplier_user_id,
                        dealerUserId: _this.infoObj.dealer_user_id,
                        orderPurchaseNumber: _this.infoObj.orderNumberShow , 
                        billOrderId:_this.infoObj.bill_order_id,
                        orderPaymentState:state,
                        orderPaymentNumber: _this.infoObj.order_number, 
                    }
                    console.log(arg)
                    confirmRequestPayment(arg).then(res => {
                        console.log(res)
                        if (res.errorCode == 200) {
                            this.$message.success("确认支付凭证成功")
                            _this.closeModalAndSuccess()
                        } else {
                            this.$message.error(res.errorMsg)
                        }
                    })
                }else{
                    console.log("这里是清算付款确认")
                    let arg = {
                        liquidateOrderId:_this.infoObj.parent_order_id, 
                        billOrderId:_this.infoObj.bill_order_id,
                        liquidatePaymentState:state,
                        orderPaymentNumber: _this.infoObj.order_number, 
                    }
                    console.log(arg)
                    confirmRequestPaymentByOrder(arg).then(res => {
                        console.log(res)
                        if (res.errorCode == 200) {
                            this.$message.success("确认支付凭证成功")
                            _this.closeModalAndSuccess()
                        } else {
                            this.$message.error(res.errorMsg)
                        }
                    })
                }
            }
        },
        created() {
          this.uploadFileApi = uploadFileApi
          this.uploadData.imageUserId = this.userId  
        },
        mounted() {

        }
    }
</script>

<style scoped lang="scss">
    textarea{border-radius: 4px;border:1px solid #C4C6CF;padding:6px 9px ;margin-top:8px;}
    .payModalWrap {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100;
        
        .oneImgBox:hover{border-color: red;}
        .oneImgBox{
            display: inline-block; border:1px dashed #ccc;margin-right: 15px;position: relative;
            
            .uploadImgAvatar{
               width: 120px;height: 120px;
               img{max-width: 100%;max-height: 100%;}
            }
            .imgDeleteBox{
                position: absolute;cursor: pointer;
                width: 100%; text-align: center;background: rgba(0,0,0,0.3);color:#ddd;bottom:0px;font-size: 12px;padding:5px 0;
            }
            .imgDeleteBox:hover{color:red;background: rgba(0,0,0,0.7);}
        }

        .mask {
            background: rgba(0, 0, 0, 0.5);
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .modalContent{
            padding:0 24px; 
        }
        .payModalBox {
            position: fixed;
            z-index: 1000;
            left: 25%;
            top: 3%;
            max-height: 95%;
            width: 50%;
            min-width: 460px;
            overflow: auto;
            border: 1px solid #eee;
            border-radius: 4px;
            background: #fff;
            border-radius: 2px;

            input {
                border: 1px solid #ddd;
                border-radius: 4px;
                padding: 8px;
            }

            .title {
                font-size: 18px;
                padding: 19px 25px;
                border-bottom: 1px solid #eee;
            }

            .oneArea {
                margin: 20px 0;
            }

            .oneline {
                margin: 8px 0;
                color:#000;opacity: 0.85;font-size: 16px;
                
            }
            .oneline.small{font-size: 12px;}

            .firstArea {
                .oneline {
                }
            }
            .twoArea{
                background: #f9f9f9;padding:16px 24px;
                .oneline {
                    margin: 4px 0; color:#333;opacity: 1;
                }
            }

            .mylabel {}
            // .mylabel.label1{display: inline-block;width: 260px;}
            // .mylabel.label2{display: inline-block;width: 260px;}

            .text {}

            .footer {
                text-align: right;
                border-top: 1px solid #eee;
                padding: 14px 25px;

                .btn {
                    padding: 10px 16px;
                    background: #fff;
                    font-size: 12px;
                    cursor: pointer;
                }
                .btn:hover {
                   
                }

                .closeBtn {
                    margin-right: 10px;
                    border: 1px solid #D9D9D9;
                }
                .closeBtn:hover{border:1px solid #999;}

                .submitBtn {
                    background: #F81D22;
                    color: #fff;
                    border: 0;
                }
                .submitBtn:hover { background: #f33136;}
            }
        }
    }
    
</style>
